import { useEffect, useRef } from 'react'

export default function usePolling(
  callbackFn,
  config = { deps: [], skip: false }
) {
  const handleInterval = useRef(null)

  function stopPolling() {
    clearInterval(handleInterval.current)
  }
  function startPolling() {
    handleInterval.current = setInterval(callbackFn, config?.interval ?? 15000)
  }

  useEffect(() => {
    if (!config?.skip) startPolling()
    return () => {
      if (!config?.skip) stopPolling()
    }
  }, config?.deps)

  return { stopPolling }
}
